import $ from "jquery";
import { getStore } from "./environment_config.es6";
import { isAllowedParentOrigin } from "./parentOrigin.es6";

// Listener for messages from the parent window (when embedded in an iframe).
export function handleHostSaveMessage(event) {
  // Only act on messages from an allowlisted host origin — see
  // common/parentOrigin.es6 for how the allowlist is configured.
  if (!isAllowedParentOrigin(event.origin)) return;

  if (event.data.action === "saveAndExit" || event.data.action === "triggerSave") {
    console.log("Save request received from parent window");

    // Trigger the save function if available
    if (window.ideaEnvSaveState) {
      console.log("Triggering ideaEnvSaveState");
      const reply = (action) => {
        if (event.source) {
          event.source.postMessage({ action }, event.origin);
        }
      };
      try {
        // isExit=false: the host owns exit (editorExit below); true would
        // navigate this iframe to the console's /courses page.
        window.ideaEnvSaveState(
          getStore().getState(),
          false,
          function () {
            console.log("Save completed, sending confirmation to parent");
            reply("editorSaved");
          },
          function () {
            reply("editorSaveFailed");
          }
        );
      } catch (e) {
        console.error("Host-triggered save failed:", e);
        $("#_overlay").hide();
        $("#_loading").hide();
        reply("editorSaveFailed");
      }
    } else if (window._saveAs) {
      console.log("Triggering _saveAs");
      window._saveAs();
      // Send confirmation back to parent
      if (event.source) {
        event.source.postMessage({ action: "editorSaved" }, event.origin);
      }
    }

    if (event.data.action === "saveAndExit") {
      // Send exit message after save
      setTimeout(() => {
        if (event.source) {
          event.source.postMessage({ action: "editorExit" }, event.origin);
        }
      }, 1000);
    }
  }
}
